import { render, staticRenderFns } from "./EventBar.vue?vue&type=template&id=3c131016&scoped=true"
import script from "./EventBar.vue?vue&type=script&lang=js"
export * from "./EventBar.vue?vue&type=script&lang=js"
import style0 from "./EventBar.vue?vue&type=style&index=0&id=3c131016&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c131016",
  null
  
)

export default component.exports